
    import {Options, Vue} from 'vue-property-decorator';
    import {Getter} from 'vuex-class';
    import BriefLoader from '@/brief-hub/common/ui/components/BriefLoader.vue';
    import BriefError from '@/brief-hub/common/ui/components/BriefError.vue';
    import UserResource from '@/brief-hub/user/UserResource';

    @Options({
        name: 'App',
        components: {
            BriefLoader,
            BriefError,
        },
    })
    export default class CustomerBriefsApp extends Vue {
        @Getter('loading')
        loading!: boolean;

        @Getter('error')
        error!: boolean;

        @Getter('connectedUser')
        connectedUser!: UserResource | null;
    }
